/**
 * Returns a route-based key that changes on every SPA navigation.
 * Used as `key` prop on <AdBanner> to force React remount.
 *
 * This hook has NO side effects. The centralized push logic lives
 * exclusively in Layout.tsx to avoid duplicate push({}) calls.
 */

import { useLocation } from 'react-router-dom';

export function useAdsRefresh(): string {
  const location = useLocation();
  return `${location.pathname}${location.search}`;
}
